import React, { useMemo } from 'react'
import { Breadcrumb } from 'antd'
import { Link, useLocation } from 'react-router-dom'
import { useBreadcrumb, BreadcrumbItem } from '../../../contexts/BreadcrumbContext'
import { useTranslation } from '../../../hooks/useTranslation'
import { SUB_APPS } from '../../../theme/subApps'

const HOME: BreadcrumbItem = { label: 'Giro', to: '/' }

const HeaderBreadcrumb: React.FC = () => {
  const { items } = useBreadcrumb()
  const location = useLocation()
  const { t } = useTranslation()

  const routeLabelMap = useMemo<Record<string, string>>(
    () => ({
      '/dashboard': t('navigation.dashboard'),
      '/reports':   t('navigation.reports'),
      '/documents': t('navigation.documents'),
      '/settings':  t('navigation.settings'),
      ...Object.fromEntries(SUB_APPS.map((s) => [s.route, t(s.labelKey)])),
    }),
    [t],
  )

  // Route-derived fallback when no page has set context items.
  const derived = useMemo<BreadcrumbItem[]>(() => {
    const segments = location.pathname.split('/').filter(Boolean)
    if (segments.length === 0) return [HOME]
    const out: BreadcrumbItem[] = [HOME]
    let path = ''
    for (let i = 0; i < segments.length; i++) {
      path += '/' + segments[i]
      const label = routeLabelMap[path] ?? capitalize(segments[i])
      out.push({ label, to: i < segments.length - 1 ? path : undefined })
    }
    return out
  }, [location.pathname, routeLabelMap])

  const final = items && items.length > 0 ? items : derived

  return (
    <Breadcrumb
      className="gt-header-breadcrumb"
      items={final.map((item) => ({
        title: item.to ? <Link to={item.to}>{item.label}</Link> : item.label,
      }))}
    />
  )
}

function capitalize(s: string) {
  return s.charAt(0).toUpperCase() + s.slice(1)
}

export default HeaderBreadcrumb
